import { useToast } from '../context/ToastContext';

export const useGameToasts = () => {
    const { addToast } = useToast();

    // Toast: Usuario ingresa a la app
    const toastWelcome = (userName) => {
        addToast(
            `¡Bienvenido, ${userName}! Vuelve a jugar y aprende más sobre la Biblia.`,
            'welcome',
            3000
        );
    };

    // Toast: Capítulo revelado
    const toastChapterRevealed = (libroNombre, capitulo, versiculo) => {
        addToast(
            `📖 ${libroNombre} ${capitulo} revelado: "${versiculo}"`,
            'chapter',
            4000
        );
    };

    // Toast: Libro completado
    const toastBookCompleted = (libroNombre, puntos) => {
        addToast(
            `✨ Nivel superado, has completado el libro de ${libroNombre}`,
            'book',
            5000
        );
    };

    // Toast: Logro desbloqueado
    const toastAchievementUnlocked = (logroNombre, puntos, descripcion) => {
        const message = descripcion
            ? `🏆 ${logroNombre} - ${descripcion} +${puntos} pts`
            : `🏆 ¡${logroNombre}! +${puntos} puntos`;

        addToast(message, 'achievement', 5000);
    };

    return {
        toastWelcome,
        toastChapterRevealed,
        toastBookCompleted,
        toastAchievementUnlocked
    };
};
